import React, { useState } from "react";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { IoCheckmarkDone } from "react-icons/io5";
import { FaPlay } from "react-icons/fa";
import { NavLink } from "react-router-dom";

import { PALETTE } from "../../common/ThemeConstants";
import FullScreenVideo from "../../common/components/FullScreenVideo";

export default function CardWorkoutExercise({
  exercise,
  idxSuperserie,
  idxExercise,
  toDetails,
  nCompleted,
  nTotToComplete,
  onCompleted,
  height = 100,
}) {
  const [playing, setPlaying] = useState(false);
  const isCompleted = nCompleted == nTotToComplete;

  // Function to handle closing the video
  const handleCloseVideo = () => {
    setPlaying(false);
  };

  return (
    <>
      <FullScreenVideo
        url={exercise.video}
        show={playing}
        onClose={handleCloseVideo}
      />
      <div className={`my-2 rounded-md ${!isCompleted && "shadow-sm"}`} style={{ border: isCompleted ? "1px solid " + PALETTE.VERYKINDALIGHTGRAY : "none" }}>
        <Row className="g-0 align-items-center rounded-md" style={{ background: PALETTE.WHITE }}>
          <Col xs={4} className="align-self-center">
            <div
              className="rounded-md align-items-center"
              onClick={!isCompleted ? () => setPlaying(true) : () => { }}
              style={{
                height: height,
                maxWidth: height,
                display: "flex",
                backgroundImage: "url(" + exercise.cover + ")",
                backgroundSize: "cover",
                border: "2px solid white",
                cursor: !isCompleted ? "pointer" : "",
                opacity: isCompleted ? 0.3 : 1
              }}
            >
              <div
                className="text-center align-items-center m-auto align-self-center"
                style={{ height: "80%", width: "80%", background: PALETTE.CIRCLETRANSPARENTGRADIENT, display: "flex" }}>
                <FaPlay className="align-items-center text-center m-auto" color={PALETTE.WHITE} />
              </div>

            </div>
          </Col>
          <Col
            xs={6}
            style={{
              paddingLeft: "4px",
              opacity: isCompleted ? 0.3 : 1
            }}>
            <NavLink
              to={!isCompleted ? toDetails : ""}
              className="text-dark text-decoration-none"
              style={{
                display: "block",
                cursor: !isCompleted ? "pointer" : "default"
              }}
            >
              <p style={{ marginBottom: "2px", fontWeight: "bold" }}>
                {exercise.name}
              </p>
              {exercise.weight > 0 && (
                <p
                  className="cardDescription mb-0"
                  style={{
                    color: PALETTE.DARKGRAY,
                    fontSize: "0.8rem"
                  }}
                >
                  {" "}
                  Peso: {exercise.weight} KG
                </p>
              )}
              {exercise.repetitions > 0 && (
                <p
                  className="cardDescription mb-0"
                  style={{
                    color: PALETTE.DARKGRAY,
                    fontSize: "0.8rem"
                  }}
                >
                  {" "}
                  Ripetizioni: {exercise.repetitions}
                  {exercise.both_sides ? " (per lato)" : ""}
                </p>
              )}
              {exercise.duration > 0 && (
                <p
                  className="cardDescription mb-0"
                  style={{
                    color: PALETTE.DARKGRAY,
                    fontSize: "0.8rem"
                  }}
                >
                  {" "}
                  Mantieni: {exercise.duration}''
                  {exercise.both_sides ? " (per lato)" : ""}
                </p>
              )}
              {exercise.centimeters > 0 && (
                <p
                  className="cardDescription mb-0"
                  style={{
                    color: PALETTE.DARKGRAY,
                    fontSize: "0.8rem"
                  }}
                >
                  {" "}
                  Centimeters: {exercise.centimeters}
                </p>
              )}
              {exercise.rest > 0 && (
                <p
                  className="cardDescription mb-0"
                  style={{
                    color: PALETTE.DARKGRAY,
                    fontSize: "0.8rem"
                  }}
                >
                  {" "}
                  Riposa: {exercise.rest}''
                </p>
              )}
            </NavLink>
          </Col>
          <Col xs={2} className="align-self-center text-center">
            {isCompleted ?
              <IoCheckmarkDone
                size={28}
                color={PALETTE.WHITE}
                className="rounded-pill p-1"
                onClick={() => onCompleted(idxSuperserie, idxExercise)}
                style={{ cursor: "pointer", zIndex: 4001, background: PALETTE.MAINCOLOR }}
              />
              :
              nCompleted == 0 ?
                <IoCheckmarkDone
                  size={28}
                  color={PALETTE.GRAY}
                  className="rounded-pill p-1"
                  onClick={() => onCompleted(idxSuperserie, idxExercise)}
                  style={{ cursor: "pointer", border: "1px solid " + PALETTE.GRAY }}
                />
                :
                <div
                  className="rounded-pill text-center align-self-center"
                  style={{
                    width: 28,
                    height: 28,
                    color: PALETTE.WHITE,
                    background: PALETTE.MAINCOLOR,
                    cursor: "pointer",
                    fontSize: 14,
                    display: "inline-flex"
                  }}
                  onClick={() => onCompleted(idxSuperserie, idxExercise)}
                >
                  <p className="text-center m-auto">x<span style={{ fontWeight: "bold" }}>{nCompleted}</span></p>
                </div>

            }
          </Col>
        </Row>
      </div>
    </>
  );
}
